var _defs, _mask, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArrowChevronLeft(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 12,
    height: 21,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M13.445 9.523a1.094 1.094 0 1 1 1.547-1.546l8.75 8.75c.427.427.427 1.12 0 1.546l-8.75 8.75a1.094 1.094 0 1 1-1.547-1.546l7.977-7.977-7.977-7.977Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "none",
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1
    },
    transform: "matrix(-1 0 0 1 25 -7)"
  }, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    width: "100%",
    height: "100%"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    width: "100%",
    height: "100%",
    style: {
      fill: "#f60",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#b)",
    style: {
      fill: "#f50",
      fillRule: "evenodd"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h35v35H0z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowChevronLeft);
export default __webpack_public_path__ + "static/media/arrow_chevron_left.b1c4d3e250e49a888f9c58e7feb556ab.svg";
export { ForwardRef as ReactComponent };